import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootSessionFromHash } from "@/lib/api";

// Doit tourner AVANT le premier render React, sinon UserContext.refresh() part
// sans le token et la première /auth/me renvoie 401 → flash de /login.
bootSessionFromHash();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
